export const ONBOARDING_DOCUMENTS_PENDING_KEY = 'pendingOnboardingDocuments';
